import { Stack } from '@chakra-ui/react';

import OptionsContent from '../../../../../../../components/FormSectionsContent/OptionsContent';
import PresetsCallout from '../../../../../../../components/PresetsCallout';
import { useInvoiceFormContext } from '../../../context';

const Options = () => {
  const { metadata } = useInvoiceFormContext();

  return (
    <Stack spacing="space-16">
      <PresetsCallout />

      <OptionsContent minLatePaymentFee={metadata.minLatePaymentFee} />
    </Stack>
  );
};

export default Options;
